import { Base } from "./base";

export class Product extends Base {
    ProductID?: string;
    OwnerID?: string;
    TariffID?: number;
    Code?: string;
    Discount?: number;
    Duration?: number;
    Title?: string;

    // Navigation properties
    ParkingID?: number;
}